import { z } from 'zod';

const envSchema = z.object({
  VITE_API_URL: z.url(),
  VITE_APP_ENV: z.enum(['development', 'staging', 'production']).default('development'),
  VITE_ENABLE_ANALYTICS: z.stringbool().default(false),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('Invalid environment configuration', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment configuration. Check your VITE_* variables.');
}

export const env = {
  apiUrl: parsed.data.VITE_API_URL,
  appEnv: parsed.data.VITE_APP_ENV,
  enableAnalytics: parsed.data.VITE_ENABLE_ANALYTICS,
};
